{
  "version": 1,
  "asset_id": "c03db437-3086-4187-8269-f0975a93dde0",
  "project_id": "115256dd-a6cc-4bc1-95c1-d787d4c0e481",
  "url": "/__l5e/assets-v1/c03db437-3086-4187-8269-f0975a93dde0/marine-hero.webp",
  "r2_key": "a/v1/115256dd-a6cc-4bc1-95c1-d787d4c0e481/c03db437-3086-4187-8269-f0975a93dde0/marine-hero.webp",
  "original_filename": "marine-hero.webp",
  "size": 82062,
  "content_type": "image/webp",
  "created_at": "2026-06-27T00:31:13Z"
}
